import { render, staticRenderFns } from "./AddDeliveryModal.vue?vue&type=template&id=44d463e1&scoped=true&"
import script from "./AddDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./AddDeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDeliveryModal.vue?vue&type=style&index=0&id=44d463e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d463e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDialog,VRow,VSelect,VToolbar})
